import { Quote } from '@generated/gql/graphql';
import { BroadbandFormValues, CallPackages } from '@src/types/broadband';
import { BooleanSelection } from '@src/types/index';
import { isBroadbandQuote } from '@utils/typeCheck';

const getBroadbandInitialValues = (selectedQuote: Quote) => {
  const initialValues: BroadbandFormValues = {
    wifiUpgrade: false,
    landline: '',
    callPackage: BooleanSelection.No,
    callPackageId: null,
    selectedTariff: '',
    includeVoip: null,
  };

  if (!isBroadbandQuote(selectedQuote)) {
    return initialValues;
  }

  const {
    id,
    requirements,
    product: { details },
  } = selectedQuote;

  const { requirement } = requirements?.[0] ?? null;

  const {
    broadbandEquipment,
    callingFeatures,
    lineCharacteristics,
    includeVoip,
  } = requirement;

  initialValues.selectedTariff = id;

  if (lineCharacteristics?.cli) {
    initialValues.landline = lineCharacteristics.cli;
  }

  if (broadbandEquipment && 'numEeros' in broadbandEquipment) {
    initialValues.wifiUpgrade = true;
  }

  if (includeVoip != null) {
    initialValues.includeVoip = includeVoip
      ? BooleanSelection.Yes
      : BooleanSelection.No;
  }

  if (details.broadbandOnly || !callingFeatures) {
    return initialValues;
  }

  if (callingFeatures[CallPackages.offPeakSaver]) {
    initialValues.callPackageId = CallPackages.offPeakSaver;
    initialValues.callPackage = BooleanSelection.Yes;
  } else if (callingFeatures[CallPackages.peakSaver]) {
    initialValues.callPackageId = CallPackages.peakSaver;
    initialValues.callPackage = BooleanSelection.Yes;
  }

  return initialValues;
};

export { getBroadbandInitialValues };
